module.exports = __webpack_public_path__ + "images/logo-aaa.png?v=04a3c8269903b02c8ca707fbe5b23dee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logo-aaa.png
// module id = 619
// module chunks = 0